import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const PaymentsList = styled.ul``

export const PaymentItem = styled.li`
  display: grid;
  align-items: center;
  column-gap: ${Spacing.S8};
  grid-template-columns: 1fr 1fr 1fr 2fr;
`
